// extracted by mini-css-extract-plugin
module.exports = {"content":"Referral_content__1-2k-","form":"Referral_form__tx26o","referral":"Referral_referral__3hdJg"};